import { SurveyTemplate } from './survey-template.model';
import { SurveyEntityType } from './survey-entity-type.enum';

/**
 * Model for Survey Configuration.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class SurveyConfiguration {
    id: number;
    entityType: SurveyEntityType;
    tabTitle: string;
    locationId: number;
    surveyTemplateName: string;
    surveyTemplateVO: SurveyTemplate;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/survey/survey-config.model.ts